<script>
import { toRef } from "vue";
import { useField } from "vee-validate";

export default {
  name: "FieldSelect",
  inject: [ 'store'],
  emits: ["onEvaluateValueResetter"],
  props: {
    field:{},
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  emits: ["onEvaluateValueResetter"],
  setup(props) {
    // use `toRef` to create reactive references to `name` prop which is passed to `useField`
    // this is important because vee-validte needs to know if the field name changes
    // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
    const name = toRef(props, "name");

    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(name, undefined, {
      initialValue: props.value,
    });
    return {
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
    };
  },
  computed:{
    selectedModel: {
      set(val) {
        this.store.calcModel[this.field.id] = val;
      },
      get() {
        return this.store.calcModel[this.field.id] || this.field.place_holder;
      }
    }
  },
  methods:{
    evaluateValueResetterForSelect(field){
      this.$emit("onEvaluateValueResetter", field)
    }
  }
}
</script>

<template>
  <select 
    @change="evaluateValueResetterForSelect(field)" 
    @input="handleChange"
    @blur="handleBlur"
    @keyup="onBlurNumber" 
    :required="this.field.allow_empty == 0 ? true : false"
    :id="field.id"
    class="form-control"
    v-model="selectedModel" 
    :name="field.title">
    <option :value="field.place_holder" selected> {{ field.place_holder }} </option>
    <template v-for="option in field.options" :key="option.value">
      <option :value="option.value">{{option.label || option.value}}</option>
    </template>
    <template v-for="newOption in store.dropDownOptions">
      <option v-if="field.id == newOption.fieldID"
        :value="newOption.newValuesObj.value" :key="newOption.newValuesObj.value">{{newOption.newValuesObj.label || newOption.newValuesObj.value}}</option>
    </template>

  </select>

  <!-- error goes here -->
</template>